export const categories = [
  {
    name: "Shoes",
    url: "https://kaspreadsheet.com/category-911-Shoes.html",
    icon: "ri-footprint-line",
    imageUrl: "https://readdy.ai/api/search-image?query=Single%20pair%20of%20elegant%20minimalist%20white%20leather%20sneakers%20placed%20on%20a%20warm%20cream%20linen%20backdrop%20with%20soft%20side%20lighting%20creating%20gentle%20shadows%2C%20clean%20editorial%20product%20photography%2C%20neutral%20beige%20tones%2C%20organic%20texture%20background&width=600&height=400&seq=cat-shoes-a1&orientation=landscape"
  },
  {
    name: "Hoodies/Sweaters",
    url: "https://kaspreadsheet.com/search-912/name/Shoes.html",
    icon: "ri-t-shirt-line",
    imageUrl: "https://readdy.ai/api/search-image?query=Soft%20oversized%20oatmeal%20colored%20hoodie%20neatly%20folded%20on%20a%20light%20textured%20linen%20surface%2C%20morning%20sunlight%20streaming%20from%20left%2C%20warm%20minimalist%20product%20photography%2C%20cozy%20aesthetic%20with%20neutral%20cream%20background&width=600&height=400&seq=cat-hoodies-b2&orientation=landscape"
  },
  {
    name: "T-Shirts",
    url: "https://kaspreadsheet.com/search-913/name/Shoes.html",
    icon: "ri-shirt-line",
    imageUrl: "https://readdy.ai/api/search-image?query=Clean%20white%20cotton%20t-shirt%20with%20subtle%20minimal%20print%20flat%20laid%20on%20warm%20beige%20paper%20backdrop%2C%20soft%20diffused%20natural%20light%2C%20editorial%20fashion%20photography%2C%20simple%20elegant%20composition%20with%20fabric%20texture%20visible&width=600&height=400&seq=cat-tshirts-c3&orientation=landscape"
  },
  {
    name: "Jackets",
    url: "https://kaspreadsheet.com/search-914/name/Shoes.html",
    icon: "ri-contrast-drop-2-line",
    imageUrl: "https://readdy.ai/api/search-image?query=Stylish%20olive%20green%20bomber%20jacket%20hung%20on%20a%20wooden%20hanger%20against%20a%20soft%20cream%20wall%2C%20gentle%20window%20light%2C%20minimalist%20product%20photography%2C%20warm%20earthy%20neutral%20tones%2C%20clean%20editorial%20style&width=600&height=400&seq=cat-jackets-d4&orientation=landscape"
  },
  {
    name: "Pants/Shorts",
    url: "https://kaspreadsheet.com/search-915/name/Shoes.html",
    icon: "ri-pantone-line",
    imageUrl: "https://readdy.ai/api/search-image?query=Well%20tailored%20beige%20linen%20trousers%20neatly%20folded%20with%20visible%20texture%20on%20a%20warm%20cream%20surface%2C%20soft%20afternoon%20light%2C%20minimalist%20fashion%20product%20photography%2C%20clean%20neutral%20aesthetic&width=600&height=400&seq=cat-pants-e5&orientation=landscape"
  },
  {
    name: "Headwear",
    url: "https://kaspreadsheet.com/search-916/name/Shoes.html",
    icon: "ri-user-5-line",
    imageUrl: "https://readdy.ai/api/search-image?query=Elegant%20minimalist%20baseball%20cap%20in%20warm%20sand%20color%20placed%20on%20a%20cream%20textured%20surface%2C%20soft%20natural%20lighting%20from%20above%2C%20clean%20product%20photography%2C%20neutral%20beige%20tones%2C%20simple%20composition&width=600&height=400&seq=cat-headwear-f6&orientation=landscape"
  },
  {
    name: "Sets",
    url: "https://kaspreadsheet.com/search-917/name/Shoes.html",
    icon: "ri-stack-line",
    imageUrl: "https://readdy.ai/api/search-image?query=Coordinated%20matching%20hoodie%20and%20jogger%20set%20in%20warm%20taupe%20color%20folded%20together%20on%20a%20light%20cream%20backdrop%2C%20soft%20diffused%20lighting%2C%20minimalist%20editorial%20fashion%20photography%2C%20cozy%20neutral%20aesthetic&width=600&height=400&seq=cat-sets-g7&orientation=landscape"
  },
  {
    name: "Underwear/Underpants",
    url: "https://kaspreadsheet.com/search-918/name/Shoes.html",
    icon: "ri-checkbox-blank-circle-line",
    imageUrl: "https://readdy.ai/api/search-image?query=Soft%20cotton%20underwear%20basics%20in%20neutral%20earth%20tones%20neatly%20arranged%20on%20a%20warm%20cream%20textured%20surface%2C%20gentle%20morning%20light%2C%20minimalist%20product%20photography%2C%20clean%20simple%20composition&width=600&height=400&seq=cat-underwear-h8&orientation=landscape"
  },
  {
    name: "Jersey",
    url: "https://kaspreadsheet.com/search-919/name/Shoes.html",
    icon: "ri-flag-2-line",
    imageUrl: "https://readdy.ai/api/search-image?query=Premium%20sports%20jersey%20in%20classic%20design%20laid%20flat%20on%20a%20light%20beige%20linen%20backdrop%2C%20soft%20natural%20window%20light%2C%20editorial%20product%20photography%2C%20warm%20neutral%20tones%2C%20clean%20minimal%20composition&width=600&height=400&seq=cat-jersey-i9&orientation=landscape"
  },
  {
    name: "Accessories",
    url: "https://kaspreadsheet.com/search-920/name/Shoes.html",
    icon: "ri-glasses-line",
    imageUrl: "https://readdy.ai/api/search-image?query=Elegant%20minimalist%20sunglasses%20and%20a%20silver%20watch%20artfully%20arranged%20on%20a%20warm%20cream%20surface%2C%20soft%20side%20lighting%2C%20editorial%20product%20photography%2C%20neutral%20beige%20tones%2C%20clean%20sophisticated%20composition&width=600&height=400&seq=cat-accessories-j10&orientation=landscape"
  },
  {
    name: "Bags",
    url: "https://kaspreadsheet.com/search-921/name/Shoes.html",
    icon: "ri-briefcase-line",
    imageUrl: "https://readdy.ai/api/search-image?query=Stylish%20minimalist%20canvas%20tote%20bag%20in%20warm%20sand%20color%20standing%20on%20a%20cream%20textured%20surface%2C%20soft%20natural%20lighting%2C%20clean%20product%20photography%2C%20neutral%20beige%20aesthetic%2C%20simple%20elegant%20composition&width=600&height=400&seq=cat-bags-k11&orientation=landscape"
  },
  {
    name: "Belts",
    url: "https://kaspreadsheet.com/search-922/name/Shoes.html",
    icon: "ri-link",
    imageUrl: "https://readdy.ai/api/search-image?query=Elegant%20brown%20leather%20belt%20coiled%20gracefully%20on%20a%20warm%20cream%20linen%20surface%2C%20soft%20side%20lighting%2C%20minimalist%20product%20photography%2C%20neutral%20tones%2C%20clean%20editorial%20style%20with%20texture%20details&width=600&height=400&seq=cat-belts-l12&orientation=landscape"
  },
  {
    name: "Perfumes",
    url: "https://kaspreadsheet.com/search-923/name/Shoes.html",
    icon: "ri-drop-line",
    imageUrl: "https://readdy.ai/api/search-image?query=Minimalist%20glass%20perfume%20bottle%20with%20warm%20amber%20liquid%20on%20a%20cream%20textured%20surface%2C%20soft%20gentle%20lighting%2C%20editorial%20product%20photography%2C%20neutral%20beige%20tones%2C%20elegant%20simple%20composition&width=600&height=400&seq=cat-perfumes-m13&orientation=landscape"
  },
  {
    name: "Other Stuff",
    url: "https://kaspreadsheet.com/search-924/name/Shoes.html",
    icon: "ri-more-line",
    imageUrl: "https://readdy.ai/api/search-image?query=Miscellaneous%20curated%20lifestyle%20items%20including%20a%20small%20notebook%20candle%20and%20keychain%20artfully%20arranged%20on%20a%20warm%20cream%20surface%2C%20soft%20natural%20light%2C%20minimalist%20product%20photography%2C%20neutral%20beige%20tones&width=600&height=400&seq=cat-other-n14&orientation=landscape"
  },
];

export const featuredProducts = [
  {
    name: "CSSBuy Shoes Spreadsheet",
    category: "Shoes",
    description: "Curated list of the best sneaker finds with QC photos and seller ratings",
    imageUrl: "https://readdy.ai/api/search-image?query=Artistic%20product%20photography%20of%20a%20pair%20of%20cream%20colored%20designer%20sneakers%20with%20subtle%20texture%20details%20on%20a%20warm%20beige%20textured%20surface%2C%20dramatic%20side%20lighting%20from%20a%20large%20window%2C%20editorial%20minimalist%20style%2C%20rich%20warm%20neutral%20tones%2C%20elegant%20composition&width=800&height=900&seq=fp-shoes-v2a&orientation=portrait"
    ,
    price: "Free Access",
    url: "https://kaspreadsheet.com/category-911-Shoes.html",
    count: 200,
  },
  {
    name: "CSSBuy Hoodies & Sweaters",
    category: "Hoodies/Sweaters",
    description: "Premium streetwear hoodie spreadsheet with size charts and agent links",
    imageUrl: "https://readdy.ai/api/search-image?query=Beautifully%20styled%20oversized%20cream%20knit%20sweater%20draped%20casually%20on%20a%20light%20beige%20linen%20backdrop%2C%20gentle%20morning%20sunlight%2C%20editorial%20fashion%20photography%2C%20warm%20cozy%20neutral%20aesthetic%20with%20visible%20knit%20texture&width=800&height=900&seq=fp-hoodies-v2b&orientation=portrait"
    ,
    price: "Free Access",
    url: "https://kaspreadsheet.com/search-912/name/Shoes.html",
    count: 150,
  },
  {
    name: "CSSBuy T-Shirts Collection",
    category: "T-Shirts",
    description: "Best budget graphic tees and basics spreadsheet updated weekly",
    imageUrl: "https://readdy.ai/api/search-image?query=Minimalist%20flat%20lay%20of%20a%20soft%20sage%20green%20cotton%20t-shirt%20with%20delicate%20fold%20marks%20on%20a%20warm%20cream%20paper%20backdrop%2C%20soft%20diffused%20afternoon%20light%2C%20editorial%20product%20photography%2C%20calm%20neutral%20tones&width=800&height=900&seq=fp-tshirts-v2c&orientation=portrait"
    ,
    price: "Free Access",
    url: "https://kaspreadsheet.com/search-913/name/Shoes.html",
    count: 180,
  },
];

export const testimonials = [
  {
    name: "Marcus J.",
    role: "CSSBuy User since 2024",
    headline: "Saved hours of searching",
    body: "The spreadsheet made finding quality items so much easier. I don't have to scroll through endless threads anymore. Everything is organized and updated.",
    rating: 5,
  },
  {
    name: "Elena R.",
    role: "Fashion Reseller",
    headline: "Best resource for resellers",
    body: "As someone who sources items for resale, this spreadsheet is a goldmine. The QC comparisons and seller ratings save me from bad purchases every single time.",
    rating: 5,
  },
  {
    name: "David K.",
    role: "Streetwear Enthusiast",
    headline: "Finally found what I needed",
    body: "I was lost in the agent world until I found this sheet. The category breakdowns are perfect and I found pieces I never would have discovered on my own.",
    rating: 5,
  },
  {
    name: "Sophie L.",
    role: "First-time Agent User",
    headline: "Made my first haul easy",
    body: "The beginner-friendly layout helped me navigate my first purchase without any confusion. The step-by-step guides linked in the sheet were incredibly helpful.",
    rating: 5,
  },
  {
    name: "James T.",
    role: "Regular Buyer",
    headline: "Consistently updated",
    body: "What sets this spreadsheet apart is how often it gets refreshed. New finds every week and dead links get removed promptly. Really appreciate the dedication.",
    rating: 5,
  },
  {
    name: "Amira H.",
    role: "CSSBuy Community Member",
    headline: "Community-approved picks",
    body: "These aren't just random finds - you can tell the community vets each item. The notes on sizing and quality are spot on from my experience ordering.",
    rating: 5,
  },
];

export const mainSiteUrl = "https://kaspreadsheet.com";